module.exports = __webpack_public_path__ + "img/bg_inhalt_mobile.7b85e49e.jpg";